const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 58,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M484 881h28v38h-28v-38Zm1 1h26v36h-26v-36Zm-18.73 8 9.72 2.906-.26 1.094-9.72-2.906Zm21.73-3h20v1h-20v-1Zm0 8h20v1h-20v-1Zm0 9h20v1h-20v-1Zm0 8h20v1h-20v-1Zm-22-3.944 9.689-2.045.311.933-9.689 2.045Zm63.73.944-9.72-2.906.26-1.084 9.72 2.906Zm.27-18.056-9.689 2.045-.311-.933 9.689-2.045Zm-55 37.366 6.31-6.31.69.69-6.31 6.31Zm.69-57.31 6.31 6.31-.69.69-6.31-6.31Zm45.31.69-6.31 6.31-.69-.69 6.31-6.31Zm-.69 57.31-6.31-6.31.69-.69 6.31 6.31Z",
    transform: "translate(-466 -871)",
    style: {
      fill: "#a0a3a7",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContent);
export default __webpack_public_path__ + "static/media/no_content.488744b2b95e5a3b125b3c04f52e73dc.svg";
export { ForwardRef as ReactComponent };